export const TRANSACTION_STATUS = {
  QR_CODE_EXPIRED: 'QRCodeExpired',
  CANCEL_TRANSACTION: 'cancelTransaction'
}
